import React, { useEffect } from 'react';
import './ZohoContactForm.scss';

const ZohoContactForm = ({ variant = 'default' }) => {
    useEffect(() => {
        // Load Zoho validation script
        const script = document.createElement('script');
        script.src = '/zoho-validation.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className={`zoho-contact-form-wrapper ${variant === 'homepage' ? 'homepage-variant' : ''}`}>
            <form
                action='https://forms.zohopublic.eu/ampedtherapeutics1/form/ScheduleYourConsultationForm/formperma/5qDMSVgPQ6bghmRsiuvy2Pa5L3_t2p99BEDikKBGSYs/htmlRecords/submit'
                name='form'
                method='POST'
                onSubmit={(e) => {
                    if (typeof window.zf_ValidateAndSubmit === 'function') {
                        document.charset = "UTF-8";
                        if (!window.zf_ValidateAndSubmit()) {
                            e.preventDefault();
                            return false;
                        }
                    }
                }}
                acceptCharset='UTF-8'
                encType='multipart/form-data'
                id='zoho-form'
                className="zoho-form"
            >
                {/* Hidden fields for Zoho */}
                <input type="hidden" name="zf_referrer_name" value="" />
                <input type="hidden" name="zf_redirect_url" value="" />
                <input type="hidden" name="zc_gad" value="" />

                {/* Form Title */}
                <div className="form-header">
                    <h2>Schedule Your Consultation</h2>
                    <p>Get started with a personalized evaluation of your condition</p>
                </div>

                {/* Name Fields */}
                <div className="form-row">
                    <div className="form-group half">
                        <label htmlFor="Name_First">
                            First Name <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            id="Name_First"
                            name="Name_First"
                            maxLength="255"
                            fieldType="7"
                            placeholder="First Name"
                            required
                        />
                    </div>
                    <div className="form-group half">
                        <label htmlFor="Name_Last">
                            Last Name <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            id="Name_Last"
                            name="Name_Last"
                            maxLength="255"
                            fieldType="7"
                            placeholder="Last Name"
                            required
                        />
                    </div>
                </div>
                <p id="Name_error" className="error-message" style={{display: 'none'}}>Invalid value</p>

                {/* Email */}
                <div className="form-group">
                    <label htmlFor="Email">
                        Email <span className="required">*</span>
                    </label>
                    <input
                        type="email"
                        id="Email"
                        name="Email"
                        checktype="c5"
                        maxLength="255"
                        fieldType="9"
                        placeholder="your@email.com"
                        required
                    />
                    <p id="Email_error" className="error-message" style={{display: 'none'}}>Invalid value</p>
                </div>

                {/* Phone */}
                <div className="form-row">
                    <div className="form-group small">
                        <label htmlFor="PhoneNumber_countrycodeval">
                            Code <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            id="PhoneNumber_countrycodeval"
                            name="PhoneNumber_countrycodeval"
                            compname="PhoneNumber_countrycodeval"
                            checktype="c7"
                            maxLength="10"
                            phoneformat="1"
                            iscountrycodeenabled="true"
                            valtype="code"
                            placeholder="+1"
                            required
                        />
                    </div>
                    <div className="form-group large">
                        <label htmlFor="PhoneNumber_countrycode">
                            Phone Number <span className="required">*</span>
                        </label>
                        <input
                            type="tel"
                            id="PhoneNumber_countrycode"
                            name="PhoneNumber_countrycode"
                            compname="PhoneNumber"
                            checktype="c7"
                            maxLength="20"
                            phoneformat="1"
                            iscountrycodeenabled="true"
                            fieldType="11"
                            valtype="number"
                            phoneformattype="1"
                            placeholder="(555) 123-4567"
                            required
                        />
                    </div>
                </div>
                <p id="PhoneNumber_error" className="error-message" style={{display: 'none'}}>Invalid value</p>

                {/* Health Concern */}
                <div className="form-group">
                    <label htmlFor="Dropdown2">
                        What's your main health concern? <span className="required">*</span>
                    </label>
                    <select
                        id="Dropdown2"
                        name="Dropdown2"
                        checktype="c1"
                        required
                    >
                        <option value="-Select-">-Select-</option>
                        <option value="Joint Pain/Arthritis">Joint Pain/Arthritis</option>
                        <option value="Chronic Pain">Chronic Pain</option>
                        <option value="Sexual Wellness">Sexual Wellness</option>
                        <option value="Neurological Issues">Neurological Issues</option>
                        <option value="Sports Injury">Sports Injury</option>
                        <option value="Anti-Aging">Anti-Aging</option>
                        <option value="Developmental Disorders - Autism Spectrum">Developmental Disorders - Autism Spectrum</option>
                        <option value="Neurodegenerative and Dementia Therapy">Neurodegenerative and Dementia Therapy</option>
                    </select>
                    <p id="Dropdown2_error" className="error-message" style={{display: 'none'}}>Invalid value</p>
                </div>

                {/* Treatment Timeline & Budget */}
                <div className="form-row">
                    <div className="form-group half">
                        <label htmlFor="Dropdown3">
                            When are you looking to get treatment? <span className="required">*</span>
                        </label>
                        <select
                            id="Dropdown3"
                            name="Dropdown3"
                            checktype="c1"
                            required
                        >
                            <option value="-Select-">-Select-</option>
                            <option value="ASAP">ASAP</option>
                            <option value="1-3 months">1-3 months</option>
                            <option value="6-12 months">6-12 months</option>
                            <option value="Just researching">Just researching</option>
                        </select>
                        <p id="Dropdown3_error" className="error-message" style={{display: 'none'}}>Invalid value</p>
                    </div>

                    <div className="form-group half">
                        <label htmlFor="Dropdown4">
                            Budget for therapy? <span className="required">*</span>
                        </label>
                        <select
                            id="Dropdown4"
                            name="Dropdown4"
                            checktype="c1"
                            required
                        >
                            <option value="-Select-">-Select-</option>
                            <option value="Yes">Yes</option>
                            <option value="Need payment plan info (Coming soon)">Need payment plan info (Coming soon)</option>
                            <option value="Just researching costs">Just researching costs</option>
                        </select>
                        <p id="Dropdown4_error" className="error-message" style={{display: 'none'}}>Invalid value</p>
                    </div>
                </div>

                {/* Treatment Location & How did you hear */}
                <div className="form-row">
                    <div className="form-group half">
                        <label htmlFor="Dropdown5">
                            Treatment location?
                        </label>
                        <select
                            id="Dropdown5"
                            name="Dropdown5"
                            checktype="c1"
                        >
                            <option value="-Select-">-Select-</option>
                            <option value="Florida">Florida</option>
                            <option value="The Caribbean">The Caribbean</option>
                        </select>
                        <p id="Dropdown5_error" className="error-message" style={{display: 'none'}}>Invalid value</p>
                    </div>

                    <div className="form-group half">
                        <label htmlFor="Dropdown">
                            How did you hear about us? <span className="required">*</span>
                        </label>
                        <select
                            id="Dropdown"
                            name="Dropdown"
                            checktype="c1"
                            required
                        >
                            <option value="-Select-">-Select-</option>
                            <option value="Google/Internet Search">Google/Internet Search</option>
                            <option value="Referral from Doctor">Referral from Doctor</option>
                            <option value="Social Media">Social Media</option>
                            <option value="Conference/Event">Conference/Event</option>
                            <option value="Friend/Family Referral">Friend/Family Referral</option>
                            <option value="Referral from Russ McKinnon">Referral from Russ McKinnon</option>
                        </select>
                        <p id="Dropdown_error" className="error-message" style={{display: 'none'}}>Invalid value</p>
                    </div>
                </div>

                {/* Doctor Referral */}
                <div className="form-group">
                    <label htmlFor="SingleLine">
                        Which Doctor Referred you?
                    </label>
                    <input
                        type="text"
                        id="SingleLine"
                        name="SingleLine"
                        checktype="c1"
                        maxLength="255"
                        fieldType="1"
                        placeholder="Doctor's name (if applicable)"
                    />
                    <p id="SingleLine_error" className="error-message" style={{display: 'none'}}>Invalid value</p>
                </div>

                {/* Submit Button */}
                <div className="form-submit">
                    <button type="submit" className="submit-btn">
                        Schedule My Consultation
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ZohoContactForm;
